import { asyncScheduler, from, Observable, scheduled } from 'rxjs';
import { Action } from 'redux';
import { DataStatus, EpicDeps } from 'src/core/engine';

import { Msg, STORAGE_KEY_CART } from '../cart.actions';

/**
 * This is all about the first page load - deciding whether or not
 * to use a local-storage value, or to just 'refresh'
 *
 * NOTE: we have to delay the initial actions from this epic since they'd fire
 * syncronsly and may be missed by other listeners
 * @param _action$
 * @param _state$
 * @param storage
 */
export function cartHydrate(_action$, _state$, { storage }: EpicDeps): Observable<Action> {
    /**
     * read previous state from localstorage
     */
    const prev = storage.get(STORAGE_KEY_CART);

    /**
     * Is the prev 'status' valid?
     */
    const validPrev = prev && prev.status !== DataStatus.Pending && prev.status !== DataStatus.Error;

    /**
     * The refresh message
     */
    const refresh = Msg('Cart.Refresh', { force: true });

    /**
     * If we had a previous cart stored, restore it first, then refresh
     */
    const messages = validPrev && prev ? [Msg('Cart.HydrateFromLocalStorage', prev), refresh] : [refresh];

    /**
     * Delay for a 'tick' to allow other listeners to be registered
     */
    return scheduled(from(messages), asyncScheduler);
}
